import {
  Chip,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  PanelCollapsible,
  SPACING_16,
  SPACING_32,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_S
} from 'mailup-web-components'
import {
  changeWizardStepCallback,
  getFiltersCallback,
  getGroupByIdCallback
} from 'Pages/Task/recoil/callbacks/callbacks'
import {
  dynamicFieldState,
  recapState,
  taskState
} from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import {
  optionsEventFilterSelect,
  triggerFieldFilterOptions,
  triggerFieldTypeOptios
} from '../../Step3/contitions/const'

const Conditions = () => {
  const intl = useIntl()
  const task = useRecoilValue(taskState)
  const [{ conditionExpanded, conditions }, setRecapState] =
    useRecoilState(recapState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const getGroupById = useRecoilCallback(getGroupByIdCallback, [])
  const getAllFilters = useRecoilCallback(getFiltersCallback, [])
  const dynamicField = useRecoilValue(dynamicFieldState)

  const onCanchePanel = () => {
    setRecapState((prev) => ({
      ...prev,
      conditionExpanded: !prev.conditionExpanded
    }))
  }

  const goToStep = () => {
    changeWizardStep(3)
  }

  const getGroupsIncluded = async () => {
    if (task.Detail.Group.filter((f) => f.Action === 0).length > 0) {
      const resp = await Promise.all(
        task.Detail.Group.filter((f) => f.Action === 0).map((m) =>
          getGroupById(m.IdGroup)
        )
      )

      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          includeGroups: resp.map((m) => ['ID ' + m.Id + ' - ' + m.Name])
        }
      }))
    } else {
      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          includeGroups: []
        }
      }))
    }
  }

  const getGroupsExluded = async () => {
    if (task.Detail.Group.filter((f) => f.Action === 1).length > 0) {
      const resp = await Promise.all(
        task.Detail.Group.filter((f) => f.Action === 1).map((m) =>
          getGroupById(m.IdGroup)
        )
      )

      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          excludeGroups: resp.map((m) => ['ID ' + m.Id + ' - ' + m.Name])
        }
      }))
    } else {
      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          excludeGroups: []
        }
      }))
    }
  }

  const getFilters = async () => {
    if (
      (task.Detail.Filter && task.Detail.Filter.length > 0) ||
      task.Detail.ApplyConditionsFilter
    ) {
      const filters = await getAllFilters()

      if (task.Detail.Filter && task.Detail.Filter.length > 0) {
        const resp = task.Detail.Filter.map((m) =>
          filters.find((e) => e.value === m.IdFilter)
        )

        setRecapState((prev) => ({
          ...prev,
          conditions: {
            ...prev.conditions,
            filters: resp.map((m) => ['ID ' + m.label])
          }
        }))
      } else {
        setRecapState((prev) => ({
          ...prev,
          conditions: {
            ...prev.conditions,
            filters: []
          }
        }))
      }

      if (task.Detail.ApplyConditionsFilter) {
        setRecapState((prev) => ({
          ...prev,
          conditions: {
            ...prev.conditions,
            anagFilterTrue:
              task.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 0 && f.Action === 0
              ).length > 0
                ? filters.find(
                    (r) =>
                      r.value ===
                      task.Detail.TaskApplyConditionsFilter.find(
                        (f) => f.TypeOfFilter === 0 && f.Action === 0
                      ).IdFilter
                  ).label
                : '',
            anagFilterFalse:
              task.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 0 && f.Action === 1
              ).length > 0
                ? filters.find(
                    (r) =>
                      r.value ===
                      task.Detail.TaskApplyConditionsFilter.find(
                        (f) => f.TypeOfFilter === 0 && f.Action === 1
                      ).IdFilter
                  ).label
                : '',
            otherFilterTrue:
              task.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 1 && f.Action === 0
              ).length > 0
                ? filters.find(
                    (r) =>
                      r.value ===
                      task.Detail.TaskApplyConditionsFilter.find(
                        (f) => f.TypeOfFilter === 1 && f.Action === 0
                      ).IdFilter
                  ).label
                : '',
            otherFilterFalse:
              task.Detail.TaskApplyConditionsFilter.filter(
                (f) => f.TypeOfFilter === 1 && f.Action === 1
              ).length > 0
                ? filters.find(
                    (r) =>
                      r.value ===
                      task.Detail.TaskApplyConditionsFilter.find(
                        (f) => f.TypeOfFilter === 1 && f.Action === 1
                      ).IdFilter
                  ).label
                : ''
          }
        }))
      } else {
        setRecapState((prev) => ({
          ...prev,
          conditions: {
            ...prev.conditions,
            anagFilterTrue: '',
            anagFilterFalse: '',
            otherFilterTrue: '',
            otherFilterFalse: ''
          }
        }))
      }
    } else {
      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          filters: [],
          anagFilterTrue: '',
          anagFilterFalse: '',
          otherFilterTrue: '',
          otherFilterFalse: ''
        }
      }))
    }
  }
  useEffect(() => {
    if (task.Detail.Group && task.Detail.Group.length > 0) {
      getGroupsIncluded()
      getGroupsExluded()
    } else {
      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          includeGroups: [],
          excludeGroups: []
        }
      }))
    }
    if (
      (task.Detail.Filter && task.Detail.Filter.length > 0) ||
      task.Detail.ApplyConditionsFilter
    ) {
      getFilters()
    } else {
      setRecapState((prev) => ({
        ...prev,
        conditions: {
          ...prev.conditions,
          filters: [],
          anagFilterTrue: '',
          anagFilterFalse: '',
          otherFilterTrue: '',
          otherFilterFalse: ''
        }
      }))
    }
  }, [])

  return (
    <PanelCollapsible
      title={intl.formatMessage({ id: 'Load.Task.Step3Condictions' })}
      collapsed={!conditionExpanded}
      onChange={onCanchePanel}
      beforeCollapseChildren={
        <Link
          data-mu-test='task-5-conditions'
          onClick={goToStep}
          variant={LINK_VARIANT_EXTRALIGHT}
        >
          {intl.formatMessage({ id: 'Load.Task.ReviewEdit' })}
        </Link>
      }
    >
      <Grid cols={3}>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewIncludedGroups' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          {conditions.includeGroups.length === 0 && <Text>-</Text>}
          {conditions.includeGroups.length > 0 && (
            <Flex gap='8px'>
              {conditions.includeGroups.map((item, key) => (
                <FlexItem key={key}>
                  <Chip label={item} />
                </FlexItem>
              ))}
            </Flex>
          )}
        </GridCell>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {intl.formatMessage({ id: 'Load.Task.ReviewExludedGroups' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          {conditions.excludeGroups.length === 0 && <Text>-</Text>}
          {conditions.excludeGroups.length > 0 && (
            <Flex gap='8px'>
              {conditions.excludeGroups.map((item, key) => (
                <FlexItem key={key}>
                  <Chip label={item} />
                </FlexItem>
              ))}
            </Flex>
          )}
        </GridCell>
        <GridCell span={1}>
          <Title variant={TITLE_VARIANT_S}>
            {conditions.filters.length === 0 &&
              intl.formatMessage({ id: 'Load.Task.ReviewAppliedFilters' })}

            {conditions.filters.length === 1 &&
              intl.formatMessage({ id: 'Load.Task.ReviewAppliedOneFilter' })}

            {conditions.filters.length > 1 &&
              intl.formatMessage({ id: 'Load.Task.ReviewAppliedAllFilters' })}
          </Title>
          <SpacingVertical variant={SPACING_8} />
          {conditions.filters.length === 0 && <Text>-</Text>}
          {conditions.filters.length > 0 && (
            <Flex gap='8px'>
              {conditions.filters.map((item, key) => (
                <FlexItem key={key}>
                  <Chip label={item} />
                </FlexItem>
              ))}
            </Flex>
          )}
        </GridCell>
      </Grid>
      {(task.Detail.ApplyConditionsEvent ||
        task.Detail.ApplyConditionsField ||
        conditions.anagFilterTrue ||
        conditions.anagFilterFalse ||
        conditions.otherFilterTrue ||
        conditions.otherFilterFalse) && (
        <>
          <SpacingVertical variant={SPACING_32} />
          <Title variant={TITLE_VARIANT_S}>
            {task.Detail.ApplyConditionsRule === 'AND'
              ? intl.formatMessage({ id: 'Load.Task.ReviewAllConditions' })
              : intl.formatMessage({ id: 'Load.Task.ReviewAnyCondition' })}
          </Title>
          <Flex
            margin='0 0 0 32px'
            padding='16px 0 0 0'
            flexDirection='column'
            gap='16px'
          >
            {task.Detail.ApplyConditionsEvent && (
              <li>
                <Text htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.Task.ConditionsWhenLabelRecipients'
                  })}
                </Text>{' '}
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: optionsEventFilterSelect.find(
                      (f) =>
                        f.value ===
                        task.Detail.TaskApplyConditionsEvent.IdEventFilter
                    ).label
                  })}
                </Text>{' '}
                <Text htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.Task.ConditionsWhenLabelFrom'
                  })}
                </Text>{' '}
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {task.Detail.TaskApplyConditionsEvent.DaysFromLastEvent}
                </Text>{' '}
                <Text htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.Task.ConditionsWhenLabelDays'
                  })}
                </Text>
              </li>
            )}
            {task.Detail.ApplyConditionsField && (
              <li>
                <Text htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.Task.ConditionsWhenLabelAnagraphicField'
                  })}
                </Text>{' '}
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {dynamicField.find(
                    (f) =>
                      f.value === task.Detail.TaskApplyConditionsField.IdField
                  )
                    ? dynamicField.find(
                        (f) =>
                          f.value ===
                          task.Detail.TaskApplyConditionsField.IdField
                      ).label
                    : '-'}
                </Text>{' '}
                <Text htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.Task.ConditionsWhenLabelType'
                  })}
                </Text>{' '}
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: triggerFieldTypeOptios.find(
                      (f) =>
                        f.value ===
                        task.Detail.TaskApplyConditionsField.FieldType
                    ).label
                  })}
                </Text>{' '}
                <Text htmlElement='span'>
                  {intl.formatMessage({
                    id: 'Load.Task.ConditionsWhenLabelIs'
                  })}
                </Text>{' '}
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {intl.formatMessage({
                    id: triggerFieldFilterOptions.find(
                      (f) =>
                        f.value ===
                        task.Detail.TaskApplyConditionsField.IdFieldFilter
                    ).label
                  })}
                </Text>{' '}
                <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                  {task.Detail.TaskApplyConditionsField.FieldValue}
                </Text>
              </li>
            )}
            {conditions.anagFilterTrue && (
              <li>
                <Text htmlElement='span'>
                  {intl.formatMessage(
                    { id: 'Load.Task.ConditionsAnagraphicFilterTrue' },
                    {
                      strong: (str) => <strong>{str}</strong>
                    }
                  )}
                </Text>{' '}
                <Chip label={conditions.anagFilterTrue} />
              </li>
            )}
            {conditions.anagFilterFalse && (
              <li>
                <Text htmlElement='span'>
                  {intl.formatMessage(
                    { id: 'Load.Task.ConditionsAnagraphicFilterFalse' },
                    {
                      strong: (str) => <strong>{str}</strong>
                    }
                  )}
                </Text>{' '}
                <Chip label={conditions.anagFilterFalse} />
              </li>
            )}
            {conditions.otherFilterTrue && (
              <li>
                <Text htmlElement='span'>
                  {intl.formatMessage(
                    { id: 'Load.Task.ConditionsOtherFilterTrue' },
                    {
                      strong: (str) => <strong>{str}</strong>
                    }
                  )}
                </Text>{' '}
                <Chip label={conditions.otherFilterTrue} />
              </li>
            )}
            {conditions.otherFilterFalse && (
              <li>
                <Text htmlElement='span'>
                  {intl.formatMessage(
                    { id: 'Load.Task.ConditionsOtherFilterFalse' },
                    {
                      strong: (str) => <strong>{str}</strong>
                    }
                  )}
                </Text>{' '}
                <Chip label={conditions.otherFilterFalse} />
              </li>
            )}
          </Flex>
          <SpacingVertical variant={SPACING_8} />
        </>
      )}
      <SpacingVertical />
      <Title variant={TITLE_VARIANT_S}>
        {intl.formatMessage({ id: 'Load.Task.ReviewFrequencySet' })}
      </Title>
      <SpacingVertical variant={SPACING_16} />
      {task.Detail.FrequencySafeGuard > 0 && (
        <>
          <Text htmlElement='span'>
            {intl.formatMessage({ id: 'Load.Task.ConditionsFrequencySetGap' })}
          </Text>{' '}
          <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
            {task.Detail.FrequencySafeGuard}
          </Text>{' '}
          <Text htmlElement='span'>
            {intl.formatMessage({ id: 'Load.MailupCommon.Hours' })}
          </Text>
        </>
      )}
      {task.Detail.FrequencySafeGuard === 0 && (
        <Text htmlElement='span'>
          {intl.formatMessage({ id: 'Load.Task.ConditionsFrequencyOnce' })}
        </Text>
      )}
      {task.Detail.FrequencySafeGuard < 0 && (
        <Text htmlElement='span'>
          {intl.formatMessage({ id: 'Load.Task.ConditionsFrequencyMany' })}
        </Text>
      )}
    </PanelCollapsible>
  )
}

export default Conditions
